import {
  getEventsRequested,
  getEventsSuccess,
  getEventsError
} from '../../actions/events/events'
import { setErrors } from '../../actions/shared/shared'
import axios from 'axios'
import { AxiosResponse } from 'axios'

import { hostUrl } from '../../config/config'

import { push } from 'react-router-redux'

const updateData = () => {
  const url = `${hostUrl}/GetCDHAEvents.ashx`
  return axios.post(url, {}, { withCredentials: true })
}

function status(response: AxiosResponse) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response)
  } else {
    return Promise.reject(new Error(response.statusText))
  }
}

function json(response: AxiosResponse) {
  return response.data
}

const getEvents = () => {
  return function(dispatch) {
    dispatch(getEventsRequested())
    return updateData()
      .then(status)
      .then(json)
      .then(data => {
        //if (data.hasOwnProperty('data')) {
        return dispatch(getEventsSuccess(data.data))
        // } else {
        //   throw new Error('No data was returned by the service')
        // }
      })
      .catch(error => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.data &&
          error.response.data.server_time
        ) {
        }
        dispatch(getEventsError(error))
        dispatch(
          setErrors([
            'There was a problem requesting data from server. Please try again. If problem persists, please contact CDHA.'
          ])
        )
        dispatch(push('/error'))
      })
  }
}

export default getEvents
